module.exports = __webpack_public_path__ + "img/2.0412b44c.jpg";